import {
  Button,
  Col,
  Collapse,
  Descriptions,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd';
import { Dropdown, InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import CustomPagination from 'components/table/pagination';
import Excel from 'components/table/excel';
import InputDate from 'components/inputs/InputDate';
import InputControl from 'components/inputs/InputControl';
import InputControlAsync from 'components/inputs/InputControlAsync';
import DashboardContext from 'Context';
import InputControlAsyncMulti from 'components/inputs/InputControlAsyncMulti';
import ModalDelete from 'components/tabel/ModalDelete';
import ModalDebtTracking from 'components/tabel/tabelWorker/ModalDebtTracking';
import ModalJobSituation from 'components/tabel/tabelWorker/ModalJobSituation';
import ModalUpdateSurvey from 'components/tabel/tabelWorker/ModalUpdateSurvey';

export default function OrderWorker({ workerId }) {
  const { urldashboard, authentication, handelAdd } =
    useContext(DashboardContext);
  // table data
  const [searchForm] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [record, setRecord] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [debtModal, setDebtModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [ratingModal, setRatingModal] = useState(false);
  const [moreInfoModal, setMoreInfoModal] = useState(false);
  // selected rows
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    if (
      !moreInfoModal &&
      !deleteModal &&
      !debtModal &&
      !statusModal &&
      !ratingModal
    ) {
      getWorkerSchedule({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
        formData,
      });
      setRecord({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    handelAdd,
    moreInfoModal,
    deleteModal,
    debtModal,
    statusModal,
    ratingModal,
  ]);

  const getWorkerSchedule = async ({
    page,
    pageSize,
    searchValue,
    formData,
  }) => {
    setLoading(true);
    try {
      let url = '/workerOrderSchedule/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          workerId: workerId ?? sessionStorage.getItem('workerId'),
          pageSize,
          ...formData,
          search: searchValue,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getWorkerSchedule({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
      formData,
    });
  };

  const search = () => {
    getWorkerSchedule({
      page: 1,
      pageSize: 10,
      searchValue,
      formData,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Tooltip
          title={
            record?.type === 6 || record?.type === 7
              ? 'بدلیل اینکه کار / سفارش برای نیرو لغو شده است، انجام هرگونه عملیات ممکن نیست.'
              : ''
          }
        >
          <Dropdown>
            <Dropdown.Toggle
              disabled={record?.type === 6 || record?.type === 7}
              style={{ backgroundColor: '#464dee', color: '#ffffff' }}
            ></Dropdown.Toggle>

            <Dropdown.Menu id={record?.id} align={'right'}>
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => showActionModal('delete', record)}
              >
                حذف
              </Dropdown.Item>
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => showActionModal('debt', record)}
              >
                پیگیری مالی
              </Dropdown.Item>
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => showActionModal('status', record)}
              >
                وضعیت کار
              </Dropdown.Item>
              {Object.hasOwn(record, 'survey') && (
                <Dropdown.Item
                  className={'d-inline-flex'}
                  onClick={() => showActionModal('rating', record)}
                >
                  ثبت نظر
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Tooltip>
      ),
    },
    {
      title: 'نام مشتری',
      dataIndex: 'customerName',
      key: 'customerName',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (name, record) => (
        <a
          href={`/Customer/${record?.customerId}`}
          target={'_blank'}
          rel={'noreferrer'}
        >
          {name}
        </a>
      ),
    },
    {
      title: 'عنوان سفارش',
      dataIndex: 'orderScheduleTitle',
      key: 'orderScheduleTitle',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'بخش',
      dataIndex: 'sectionName',
      key: 'sectionName',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نام نیرو',
      dataIndex: 'workerFullName',
      key: 'workerFullName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render(value, record) {
        return {
          props: {
            style: {
              background: record?.isFavorite ? 'var(--yellow)' : '',
            },
          },
          children: <span>{value ?? '-'}</span>,
        };
      },
      // render: (value, record) => <div className= {record?.isFavorite ? 'w-100 h-100 isFavorite' : ''} ><span>{value ?? '-'}</span></div>,
    },
    {
      title: 'موبایل نیرو',
      dataIndex: 'workerPhoneNo',
      key: 'workerPhoneNo',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نیروی جایگزین',
      dataIndex: 'workerPresenterName',
      key: 'workerPresenterName',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'typeTitle',
      key: 'typeTitle',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'هزینه نیرو (ریال)',
      dataIndex: 'amount',
      key: 'amount',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value?.toLocaleString()}</span>,
    },
    {
      title: 'تخفیف مشتری (ریال)',
      dataIndex: 'customerDiscount',
      key: 'customerDiscount',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value?.toLocaleString()}</span>,
    },
    {
      title: 'تاریخ شروع',
      dataIndex: 'persianStartWork',
      key: 'persianStartWork',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'ساعت ورود',
      dataIndex: 'inputTime',
      key: 'inputTime',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'ساعت خروج',
      dataIndex: 'outputTime',
      key: 'outputTime',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
    {
      title: 'اطلاعات لغو کار / سفارش',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button
          onClick={() => showActionModal('cancel', record)}
          disabled={record?.type !== 6 && record?.type !== 7}
        >
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  // actions

  const showInfoModal = (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  const showActionModal = (modalName, record) => {
    setRecord(record);
    switch (modalName) {
      case 'delete':
        setDeleteModal(true);
        break;
      case 'debt':
        setDebtModal(true);
        break;
      case 'status':
        setStatusModal(true);
        break;
      case 'rating':
        setRatingModal(true);
        break;
      case 'cancel':
        setCancelModal(true);
        break;
      default:
        break;
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Collapse defaultActiveKey={['0']}>
            <Collapse.Panel header='جستجو پیشرفته' key='1'>
              {/* */}
              <Row gutter={20}>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/profileBusinessTypeDropdown'
                    label='نوع بیزینس کار نیرو'
                    name='profileBusinessType'
                    handelValue={(_, value) =>
                      setFormData({
                        ...formData,
                        profileBusinessType: value,
                      })
                    }
                  />
                </Col>
                {formData?.profileBusinessType !== null &&
                  formData?.profileBusinessType !== undefined && (
                    <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                      {formData?.profileBusinessType === 0 ? (
                        <InputControlAsync
                          url='/userManagement/searchDropdown'
                          label='مشتری'
                          name='userId'
                          handelValue={(_, value) =>
                            setFormData({ ...formData, userId: value })
                          }
                        />
                      ) : (
                        <InputControlAsync
                          url='/userManagement/B2BSearchDropDown'
                          label='مشتری'
                          name='userId'
                          handelValue={(_, value) =>
                            setFormData({ ...formData, userId: value })
                          }
                        />
                      )}
                    </Col>
                  )}
                {formData?.userId && (
                  <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                    <InputControl
                      url={`/userManagement/addressDropdown/${formData?.userId}`}
                      label='آدرس های مشتری'
                      name='addressId'
                      patch={formData?.userId}
                      handelValue={(_, value) =>
                        setFormData({ ...formData, addressId: value })
                      }
                    />
                  </Col>
                )}
                {formData?.addressId && (
                  <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                    <InputControl
                      url={`/addressSection/getByAddressIdDropDown/${formData?.addressId}/${formData?.userId}`}
                      label='بخش'
                      isMulti
                      name='addressSectionIds'
                      handelValue={(_, value) =>
                        setFormData({ ...formData, addressSectionIds: value })
                      }
                    />
                  </Col>
                )}
              </Row>
              {/* */}
              <Row gutter={20}>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/workerStatusTypeDropdown'
                    label='وضعیت نیرو'
                    name='workerStatusType'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, workerStatusType: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/genderDropdown'
                    label='جنسیت'
                    name='gender'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, gender: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url={
                      formData?.profileBusinessType?.toString()
                        ? `/category/dropdown/${formData.profileBusinessType}`
                        : '/category/dropdown'
                    }
                    label='گروه اصلی خدمات'
                    name='categoryId'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, categoryId: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url={
                      formData.categoryId
                        ? `/group/groupdDropdown/${formData.categoryId}`
                        : '/group/groupDropdown'
                    }
                    label='دسته خدمات'
                    name='groupId'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, groupId: value })
                    }
                  />
                </Col>
              </Row>
              {/* */}
              <Row gutter={20}>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControlAsync
                    url='/worker/search'
                    label='انتخاب نیرو'
                    name='workerId'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, workerId: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/workerTypeDropdown'
                    label='نوع نیرو'
                    name='workerType'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, workerType: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/dorm/dropdown'
                    label='خوابگاه'
                    name='dormId'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, dormId: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/paymentTypeDropdown'
                    label='نوع پرداخت'
                    name='paymentType'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, paymentType: value })
                    }
                  />
                </Col>
              </Row>
              {/* */}
              <Row gutter={20}>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputDate
                    label='از تاریخ'
                    name='startDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, startDate: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputDate
                    label='تا تاریخ'
                    name='endDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, endDate: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/workerFilterTypeDropdown'
                    label='فیلتر'
                    name='workerFilterType'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, workerFilterType: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/workerOrderScheduleTypeDropdown'
                    label='نوع وضعیت کار'
                    isMulti
                    name='workerOrderScheduleTypes'
                    handelValue={(_, value) =>
                      setFormData({
                        ...formData,
                        workerOrderScheduleTypes: value,
                      })
                    }
                  />
                </Col>
              </Row>
              {/* */}
              <Row gutter={20}>
                <Col xl={5} lg={5} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/committedType'
                    label='نوع تعهد'
                    name='committedType'
                    handelValue={(_, value) =>
                      setFormData({
                        ...formData,
                        committedType: value,
                      })
                    }
                  />
                </Col>
                <Col xl={5} lg={5} md={12} sm={12} xs={24}>
                  <InputControl
                    name='workCancelPolicyId'
                    label='عنوان لغو کار'
                    url='/workCancelPolicy/getDropDown'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, workCancelPolicyId: value })
                    }
                  />
                </Col>
                <Col xl={4} lg={4} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/orderTypeDropdown'
                    label='نوع سفارش'
                    name='orderType'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, orderType: value })
                    }
                  />
                </Col>
                <Col xl={5} lg={5} md={12} sm={12} xs={24}>
                  <InputControlAsyncMulti
                    url='/userManagement/searchdropdown'
                    name='customerIds'
                    isDefaultValue={false}
                    label='مشتری ها'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, customerIds: value })
                    }
                    disabled={formData?.withoutCustomerIds?.length > 0}
                  />
                </Col>
                <Col xl={5} lg={5} md={12} sm={12} xs={24}>
                  <InputControlAsyncMulti
                    url='/userManagement/searchdropdown'
                    name='withoutCustomerIds'
                    isDefaultValue={false}
                    label='مشتری نیستند'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, customerIds: value })
                    }
                    disabled={formData?.customerIds?.length > 0}
                  />
                </Col>
              </Row>
              {/* */}
              <Row
                gutter={20}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: 20,
                }}
              >
                <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                  <Button
                    type='primary'
                    style={{ width: '100%' }}
                    loading={loading}
                    onClick={() => search()}
                  >
                    جستجو
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>

      <Row
        gutter={20}
        style={{
          marginTop: 25,
        }}
      >
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <Form form={searchForm} layout='vertical' onFinish={search}>
            <InputGroup>
              <Input
                placeholder='جستجوی سریع (موبایل نیرو)'
                name='searchValue'
                onChange={(e) => setSearchValue(e.target.value)}
                style={{
                  height: '3rem',
                  width: '90%',
                  display: 'table-cell',
                }}
              />
              <Button
                htmlType='submit'
                style={{
                  height: '3rem',
                  width: '10%',
                  display: 'table-cell',
                  padding: 0,
                }}
              >
                <i className='mdi mdi-magnify'></i>
              </Button>
            </InputGroup>
          </Form>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Excel
              server
              fileName={'کارهای_نیرو'}
              url={'/workerOrderSchedule/getExcel'}
              props={{
                ...formData,
                page: pagination?.page,
                pageSize: pagination?.pageSize,
                workerId: workerId ?? sessionStorage.getItem('workerId'),
                search: searchValue,
              }}
            />
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        rowSelection={{
          selectedRowKeys,
          onChange: onSelectChange,
        }}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      <Modal
        title='اطلاعات بیشتر'
        closable={false}
        open={moreInfoModal}
        onCancel={() => setMoreInfoModal(false)}
        footer={[
          <Button key='back' onClick={() => setMoreInfoModal(false)}>
            بستن
          </Button>,
        ]}
        bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      >
        <Descriptions bordered column={1} size={'small'}>
          <Descriptions.Item label='نام مشتری'>
            {record?.customerName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='عنوان سفارش'>
            {record?.orderScheduleTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='بخش'>
            {record?.sectionName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='نام نیرو'>
            {record?.workerFullName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='کد ملی'>
            {record?.nationalCode ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='وضعیت'>
            {record?.typeTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='هزینه نیرو (ریال)'>
            {record?.amount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='موبایل نیرو'>
            {record?.workerPhoneNo ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ شروع'>
            {record?.persianStartWork
              ? record?.persianStartWork
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ پایان'>
            {record?.persianEndWork
              ? record?.persianEndWork
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='ساعت ورود'>
            {record?.inputTime ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='ساعت خروج'>
            {record?.outputTime ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='اضافه کار'>
            {record?.extraWorkTime ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='کد پیگیری'>
            {record?.trackingCode ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ ورود واقعی'>
            {record?.realPersionInputDateTime
              ? record?.realPersionInputDateTime
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ خروج واقعی'>
            {record?.realPersionOutputDateTime
              ? record?.realPersionOutputDateTime
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='توضیحات ثبت‌کننده ورود و خروج'>
            {record?.description ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تخفیف مشتری (ریال)'>
            {record?.customerDiscount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='تخفیف نیرو (ریال)'>
            {record?.personDiscount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='شماره مشتری'>
            {record?.customerCellPhone ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='آدرس مشتری'>
            {record?.customerAddress ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='هزینه کارهای پروژه‌ای (ریال)'>
            {record?.additionalAmount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='هزینه خدمات اضافه (ریال)'>
            {record?.propertyAmount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='پورسانت (ریال)'>
            {record?.commissionAmount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='هزینه کل (ریال)'>
            {record?.totalAmount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='خالص دریافتی (ریال)'>
            {record?.payableAmount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='ناخالص دریافتی نیرو بدون محاسبه پورسانت (ریال)'>
            {record?.grossPayableAmount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='تخفیف خدمات اضافه (ریال)'>
            {record?.propertyDiscount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='هزینه B2B (ریال)'>
            {record?.amountRealTime?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='کد تایید برای پایان کار'>
            {record?.confirmCode ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='امکانات سفارش'>
            {record?.facilities ? record?.facilities : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='مورد علاقه است؟'>
            {record?.isFavorite ? (
              <i
                className='mdi mdi-check'
                style={{ color: 'green', fontSize: '1.5rem' }}
              ></i>
            ) : (
              <i
                className='mdi mdi-close'
                style={{ color: 'red', fontSize: '1.5rem' }}
              ></i>
            )}
          </Descriptions.Item>
          <Descriptions.Item label='تسویه شده با نیرو'>
            {record?.isPaid ? (
              <i
                className='mdi mdi-check'
                style={{ color: 'green', fontSize: '1.5rem' }}
              ></i>
            ) : (
              <i
                className='mdi mdi-close'
                style={{ color: 'red', fontSize: '1.5rem' }}
              ></i>
            )}
          </Descriptions.Item>
          <Descriptions.Item label='اپلیکیشن نصب شده است؟'>
            {record?.hasAppWorker ? (
              <i
                className='mdi mdi-check'
                style={{ color: 'green', fontSize: '1.5rem' }}
              ></i>
            ) : (
              <i
                className='mdi mdi-close'
                style={{ color: 'red', fontSize: '1.5rem' }}
              ></i>
            )}
          </Descriptions.Item>
          <Descriptions.Item label='امتیاز'>
            {record?.survey ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='کد مرکز هزینه'>
            {record?.costCentreCode ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          {(record?.type === 7 || record?.type === 6) && (
            <>
              <Descriptions.Item label='نام لغو کننده'>
                {record?.cancelerName ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='توضیحات لغو'>
                {record?.cancelDescription ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              {record?.type === 7 && (
                <>
                  <Descriptions.Item label='عنوان لغو کار'>
                    {record?.policyTitle ?? 'اطلاعات وارد نشده'}
                  </Descriptions.Item>
                  <Descriptions.Item label='دلیل لغو کار'>
                    {record?.workActionReasonTitle ?? 'اطلاعات وارد نشده'}
                  </Descriptions.Item>
                  <Descriptions.Item label='مبلغ جریمه (ریال)'>
                    {record?.penaltyAmount !== null
                      ? parseInt(record?.penaltyAmount)?.toLocaleString()
                      : 'اطلاعات وارد نشده'}
                  </Descriptions.Item>
                </>
              )}
            </>
          )}
        </Descriptions>
      </Modal>

      {deleteModal && (
        <ModalDelete
          hasDescription
          id={record?.id}
          showitem={deleteModal}
          urldata={'/workerOrderSchedule'}
          handleCloseMoudal={() => setDeleteModal(false)}
          handeldeleteModal={() => setDeleteModal(false)}
        />
      )}

      {debtModal && (
        <ModalDebtTracking
          showitem={debtModal}
          handleCloseMoudal={() => setDebtModal(false)}
          id={record?.id}
        />
      )}

      {statusModal && (
        <ModalJobSituation
          sohwitem={statusModal}
          handelClosemodal={() => setStatusModal(false)}
          id={record?.id}
          //   arryactions={arryactions}
          //   handeldeleteitem={handeldeleteitem}
        />
      )}

      {ratingModal && (
        <ModalUpdateSurvey
          businessType={0}
          showitem={ratingModal}
          handleCloseMoudal={() => setRatingModal(false)}
          id={record?.id}
          isFromApp={record?.appType === 2}
          survey={record?.survey}
        />
      )}

      <Modal
        closable={false}
        open={cancelModal}
        title='اطلاعات لغو کار / سفارش'
        onCancel={() => setCancelModal(false)}
        footer={[
          <Button key='back' onClick={() => setCancelModal(false)}>
            بستن
          </Button>,
        ]}
        bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      >
        <Descriptions bordered column={1} size={'small'}>
          <Descriptions.Item label='وضعیت'>
            {record?.typeTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='نام لغو کننده'>
            {record?.cancelerName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='توضیحات لغو'>
            {record?.cancelDescription ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          {record?.type === 7 && (
            <>
              <Descriptions.Item label='عنوان لغو کار'>
                {record?.policyTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='دلیل لغو کار'>
                {record?.workActionReasonTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='مبلغ جریمه (ریال)'>
                {record?.penaltyAmount !== null
                  ? parseInt(record?.penaltyAmount)?.toLocaleString()
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
            </>
          )}
        </Descriptions>
      </Modal>
    </>
  );
}
